import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function Audience() {
  const forWhom = ['Mujeres de 40 a 60 años que sufren de hinchazón diaria.', 'Chilenas cansadas de dietas extranjeras imposibles de seguir.', 'Mujeres que necesitan soluciones prácticas y rápidas para cocinar.', 'Personas que sienten fatiga crónica y pesadez estomacal.'];
  const notForWhom = ["Personas que buscan suplementos mágicos o 'pastillas quemagrasa'.", 'Quienes no están dispuestas a cambiar la marraqueta por opciones que sí las nutran.', 'Atletas de alto rendimiento con necesidades nutricionales extremas.'];
  return <section className="py-12 md:py-14 bg-white" data-id="element-15">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl" data-id="element-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-17">
          {/* For Whom */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-brand-cream/50 p-8 sm:p-10 rounded-3xl border border-brand-gold/20" data-id="element-18">
            <h3 className="text-2xl font-serif font-bold text-brand-navy mb-8 flex items-center gap-3" data-id="element-19">
              <span className="bg-brand-gold/20 p-2 rounded-full" data-id="element-20">
                <Check className="w-6 h-6 text-brand-gold" data-id="element-21" />
              </span>
              Este método ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-22">
              {forWhom.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-23">
                  <Check className="w-6 h-6 text-brand-green shrink-0 mt-0.5" data-id="element-24" />
                  <span className="text-gray-700 leading-relaxed font-medium" data-id="element-25">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For Whom */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gray-50 p-8 sm:p-10 rounded-3xl border border-gray-200" data-id="element-26">
            <h3 className="text-2xl font-serif font-bold text-gray-800 mb-8 flex items-center gap-3" data-id="element-27">
              <span className="bg-gray-200 p-2 rounded-full" data-id="element-28">
                <X className="w-6 h-6 text-gray-500" data-id="element-29" />
              </span>
              Este método NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-30">
              {notForWhom.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-31">
                  <X className="w-6 h-6 text-gray-400 shrink-0 mt-0.5" data-id="element-32" />
                  <span className="text-gray-600 leading-relaxed" data-id="element-33">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}